import { useState } from 'react';
import { isPushSupported, getPermissionState } from '@/lib/serviceWorker';
import { useSubscribePush } from '@/hooks/usePushNotifications';
import { useUnreadNotificationCount } from '@/hooks/useNotifications';

const DISMISSED_KEY = 'linescore_push_prompt_dismissed';

export function PushPromptBanner() {
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem(DISMISSED_KEY));
  const { mutate: subscribe, isPending } = useSubscribePush();
  const { data: unreadData } = useUnreadNotificationCount();
  const notificationCount = unreadData?.count ?? 0;

  if (!isPushSupported()) return null;
  if (dismissed) return null;
  if (getPermissionState() !== 'default') return null;
  if (notificationCount === 0) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="bg-linen border-b border-sand px-4 py-2.5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <svg
          className="w-4 h-4 text-gold-text flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        <p className="font-sans text-[12px] text-ink truncate">
          Get notified when someone comments, likes, or follows
        </p>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          type="button"
          onClick={handleDismiss}
          className="font-sans text-[11px] text-warm-gray hover:text-ink transition-colors"
        >
          Not now
        </button>
        <button
          type="button"
          onClick={() => subscribe()}
          disabled={isPending}
          className="font-sans text-[11px] font-bold text-linen bg-ink px-3 py-1 rounded-[3px] hover:bg-espresso disabled:opacity-50 transition-colors"
        >
          Enable
        </button>
      </div>
    </div>
  );
}
